import React, { ReactNode } from 'react';

import { I18nextProvider } from 'react-i18next';
import i18n from './init';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';

interface GlobalizationProviderProps {
	children: ReactNode;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GlobalizationProvider = ({
	children,
}: GlobalizationProviderProps) => {
	const locale = useIsFeatureEnabled('info-360-locale');

	// Ensure locale is a string or undefined
	const language = typeof locale === 'string' ? locale : undefined;

	if (language) {
		i18n.changeLanguage(language);
	}

	return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
